import toastService from "./toastService";
import getApiError from "./apiErrorHandler";

const notify = {

    success(message) {
        toastService.success(message);
    },

    warning(message) {
        toastService.warning(message);
    },

    error(error) {
        toastService.error(
            getApiError(error)
        );
    },

    info(message) {
        toastService.info(message);
    },

};

export default notify;